import { Route, Routes } from 'react-router';
import LessonPlanner from './LessonPlanner';
import BeginnerGuide from '../guntechchatbot/components/Aichatbotlanding';
import Pagenotfound from '../components/views/PageNotFound';
import SchoolAuth from './components/SchoolAuth';
import SchoolSignIn from './components/SchoolSignIn';
import PrivateRoute from './SecurityConfig/PrivateRoute';
import AuthContextProvider from './SecurityConfig/AuthContextProvider';
import MainSectionSchool from './components/MainSectionSchool';
import ForgotPassword from './components/ForgotPassword';
import ChangePasswordWithOtp from './components/ChangePasswordWithOtp';
import SchoolLanding from './components/SchoolLandingPage';

function GuntechSchool() {
  return (
    <div className="">
      <AuthContextProvider>
        <Routes>
          <Route path="/lessonplanner">
            <Route path="" element={<SchoolLanding />} />
            <Route path="*" element={<Pagenotfound />} />
            <Route path="signup" element={<SchoolAuth />} />
            <Route path="signin" element={<SchoolSignIn />} />
            <Route path="reset-password" element={<ForgotPassword />} />
            <Route path="forgot-password" element={<ChangePasswordWithOtp />} />
            <Route
              path="dashboard"
              element={
                <PrivateRoute>
                  <MainSectionSchool LessonPlannerComponent={LessonPlanner} />
                </PrivateRoute>
              }
            />
            <Route
              path="getlesson"
              element={
                <PrivateRoute>
                  <LessonPlanner />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
      </AuthContextProvider>
    </div>
  );
}

export default GuntechSchool;